/* eslint-disable @typescript-eslint/naming-convention */
export enum SubmissionResponseType {
    PdfDownload = 'pdf_download',
    FormUpdate = 'form_update',
    VerifyUserData = 'verify_user_data',
    Login = 'login',
    Redirect = 'redirect',
}
